import { api } from "../../../api/Middleware";
import { TAGS_URL } from "../../../api/Urls";

// Obter lista de tags
export const getTags = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    if (filters.category) params.append("category", filters.category);
    if (filters.search) params.append("search", filters.search);
    if (filters.is_shared !== undefined)
      params.append("is_shared", filters.is_shared);
    if (filters.created_by) params.append("created_by", filters.created_by);
    if (filters.min_usage) params.append("min_usage", filters.min_usage);

    const queryString = params.toString();
    const url = queryString ? `${TAGS_URL}?${queryString}` : TAGS_URL;

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter tags:", error);
    throw error;
  }
};

// Obter minhas tags
export const getMyTags = async () => {
  try {
    const response = await api.get(`${TAGS_URL}my_tags/`);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter minhas tags:", error);
    throw error;
  }
};

// Obter tags compartilhadas
export const getSharedTags = async () => {
  try {
    const response = await api.get(`${TAGS_URL}shared_tags/`);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter tags compartilhadas:", error);
    throw error;
  }
};

// Buscar tags
export const searchTags = async (query, category = null, limit = 10) => {
  try {
    const params = new URLSearchParams();
    params.append("q", query);
    if (category) params.append("category", category);
    if (limit) params.append("limit", limit);

    const response = await api.get(`${TAGS_URL}search/?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar tags:", error);
    throw error;
  }
};

// Obter tags por categoria
export const getTagsByCategory = async (category = null) => {
  try {
    const url = category
      ? `${TAGS_URL}by_category/?category=${category}`
      : `${TAGS_URL}by_category/`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter tags por categoria:", error);
    throw error;
  }
};

// Obter tags populares
export const getPopularTags = async (limit = 20) => {
  try {
    const response = await api.get(`${TAGS_URL}popular/?limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter tags populares:", error);
    throw error;
  }
};

// Obter categorias
export const getCategories = async () => {
  try {
    const response = await api.get(`${TAGS_URL}categories/`);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter categorias:", error);
    throw error;
  }
};

// Obter uma tag específica
export const getTag = async (id) => {
  try {
    const response = await api.get(`${TAGS_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao obter tag ${id}:`, error);
    throw error;
  }
};

// Criar nova tag
export const createTag = async (tagData) => {
  try {
    const response = await api.post(TAGS_URL, tagData);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar tag:", error);
    throw error;
  }
};

// Atualizar tag existente
export const updateTag = async (id, tagData) => {
  try {
    const response = await api.patch(`${TAGS_URL}${id}/`, tagData);
    return response.data;
  } catch (error) {
    console.error(`Erro ao atualizar tag ${id}:`, error);
    throw error;
  }
};

// Excluir tag
export const deleteTag = async (id) => {
  try {
    const response = await api.delete(`${TAGS_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao excluir tag ${id}:`, error);
    throw error;
  }
};

// Criar múltiplas tags
export const createBulkTags = async (tagsData) => {
  try {
    const response = await api.post(`${TAGS_URL}bulk_create/`, {
      tags: tagsData,
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao criar tags em massa:", error);
    throw error;
  }
};

// Alternar compartilhamento
export const toggleShare = async (id) => {
  try {
    const response = await api.post(`${TAGS_URL}${id}/toggle_share/`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao alterar compartilhamento da tag ${id}:`, error);
    throw error;
  }
};

// Validar tags
export const validateTags = async (tags, entityType = "general") => {
  try {
    const response = await api.post(`${TAGS_URL}validate_tags/`, {
      tags,
      entity_type: entityType,
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao validar tags:", error);
    throw error;
  }
};

// Obter analytics de tags
export const getTagAnalytics = async () => {
  try {
    const response = await api.get(
      `${TAGS_URL.replace("tags/", "tag-usage/")}analytics/`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao obter analytics de tags:", error);
    throw error;
  }
};

// Excluir múltiplas tags
export const bulkDeleteTags = async (tagIds, setNotify) => {
  try {
    const response = await api.delete(`${TAGS_URL}bulk_delete/`, {
      data: { ids: tagIds },
    });

    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Tags excluídas com sucesso!",
        type: "success",
        visible: true,
      });
      return true;
    }
  } catch (error) {
    console.error("Erro ao excluir tags em massa:", error);
    setNotify({
      title: "Oops!",
      message: error.response?.data?.message || "Erro ao excluir tags",
      type: "error",
      visible: true,
    });
    throw error;
  }
};
